/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Image_Models_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to update image model configuration. Please try again." |
*
* @param {Org_Image_Models_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_image_models_save_error = /** @type {((inputs?: Org_Image_Models_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Image_Models_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildmodellkonfiguration konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to update image model configuration. Please try again.")
});